import React from 'react';
import CRUDManager from '../../../shared/components/crud/CRUDManager';
import { moduleConfig } from '../config/moduleConfig';


export default function ModulesPage() {
  return <CRUDManager config={moduleConfig} />;
}
